import { FUNCTIONS_REGION } from '@sf/shared';

export const env = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  projectId: (import.meta.env.VITE_FIREBASE_PROJECT_ID as string) || 'demo-shenandoahfirst',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string,
  functionsRegion: (import.meta.env.VITE_FUNCTIONS_REGION as string) || FUNCTIONS_REGION,
  useEmulators: import.meta.env.VITE_USE_EMULATORS === 'true',
  emulatorHost: (import.meta.env.VITE_EMULATOR_HOST as string) || '127.0.0.1',
  /** Public origin for links in auth emails (D34). Empty = the current origin. */
  publicUrl: ((import.meta.env.VITE_PUBLIC_URL as string | undefined) ?? '').trim(),
  /** Forces the site mode and skips Remote Config. Local/e2e only; never set in a deploy build (D33). */
  siteModeOverride: ((import.meta.env.VITE_SITE_MODE as string | undefined) ?? '').trim(),
  /** Mode used when Remote Config has never been fetched in this browser and the fetch fails (D33). */
  siteModeDefault: ((import.meta.env.VITE_SITE_MODE_DEFAULT as string | undefined) ?? '').trim(),
};
